import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

// https://ant.design/components/form/#components-form-demo-basic
const FormPasswordField = ({
  label,
  parentName,
  extra,
  help,
  isConfirmationField = false,
  name,
  rules = [],
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Form.Item
      label={label}
      name={name}
      extra={extra}
      help={help}
      rules={[
        ...rules,
        ({ getFieldValue }) => ({
          validator: (_, value) => {
            if (getFieldValue(parentName) === value || !isConfirmationField) {
              return Promise.resolve();
            }
            return Promise.reject(new Error(t('Heslá sa nezhodujú')));
          },
        }),
      ]}
      dependencies={isConfirmationField ? [parentName] : undefined}
      hasFeedback={isConfirmationField}
    >
      <Input.Password {...rest} />
    </Form.Item>
  );
};

export default FormPasswordField;
